import {Stack, Table, Title} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {CodePipeline} from '../types';

// Split out of Profile so the detail page can put it in the RIGHT panel of
// PlatformEditPageGrid, leaving the property cards on the left.
export const PipelineStagesPanel = ({record}: { record: CodePipeline }) => {

    if (!record.stages || record.stages.length === 0) {
        return null;
    }

    return (
        <Stack gap={'sm'}>
            <Title order={5}>{I18n.get('Pipeline Stages')}</Title>
            <Table striped highlightOnHover withTableBorder>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th>{I18n.get('Stage')}</Table.Th>
                        <Table.Th>{I18n.get('Actions')}</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {record.stages.map((stage, index) => (
                        <Table.Tr key={index}>
                            <Table.Td>{stage.name}</Table.Td>
                            <Table.Td>
                                {stage.actions?.map(a => `${a.name} (${a.provider})`).join(', ') || 'n/a'}
                            </Table.Td>
                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table>
        </Stack>
    );
};
